const routes = [
  {
    index: true,
    label: 'Lyle Christine',
    path: '/',
  },
  {
    label: 'Intro',
    path: '/intro',
  },
  {
    label: 'CV',
    path: '/cv',
  },
  {
    label: 'Apps',
    path: '/apps',
  },
  {
    label: 'Articles',
    path: '/articles',
  },
  {
    label: 'Certificates',
    path: '/certificates',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
